import React from 'react';
import { getFullUrlPath } from '../../utils/url';
import styles from './Breadcrumbs.module.scss';
export const Link = ({ breadcrumb, route, CustomLink, analytics, }) => {
    const dataLayer = {
        event: 'visitor interaction',
        interactionName: 'breadcrumb click',
        linkType: 'breadcrumb',
        linkText: route,
        linkUrl: getFullUrlPath(breadcrumb.path),
    };
    return CustomLink ? (<CustomLink path={breadcrumb.path} onClick={() => analytics && analytics(dataLayer)} className={styles.breadcrumbLink}>
      {breadcrumb.title}
    </CustomLink>) : (<a href={breadcrumb.path} onClick={() => analytics && analytics(dataLayer)} className={styles.breadcrumbLink}>
      {breadcrumb.title}
    </a>);
};
